<template>
  <div>
    <div class="mb-2">
      <div class="text-xs-right">
        <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
      </div>
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm9>
          <div>
            <v-pagination
              :total-visible="6"
              v-model="pageNumber"
              @input="changePage"
              :length="pagelength"
            ></v-pagination>
          </div>
        </v-flex>
        <v-flex xs12 sm3 class="text-xs-right">
          <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>ค้นหา</v-btn>
        </v-flex>
      </v-layout>
    </div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr :style="{ backgroundColor: props.item.member_status == 'true' ? '#e6ffe6' : 'white' }">
          <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
          <td>{{ props.item.dob | DateFormat('DD/MM/YYYY') }}</td>
          <td>{{ props.item.identity_number }}</td>
          <td>{{ props.item.phone_number }}</td>
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.linename }}</td>
          <td>{{ props.item.job }}</td>
          <td>{{ props.item.points }}</td>
          <td>
            <v-btn icon>
              <i
                @click="showImage(props.item)"
                style="font-size: 27px"
                class="primary--text far fa-id-card"
              />
            </v-btn>
          </td>
          <td class="text-xs-right">
            <v-btn @click="showEdit(props.item)" icon> <v-icon>edit</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-pagination
        :total-visible="6"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
    </div>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('ชื่อ') }}</label>
                <input v-model="filter.name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('เลขบัตรประชาชน') }}</label>
                <input v-model="filter.identityNumber" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('สาขาที่สมัคร') }}</label>
                <input v-model="filter.branch" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('เบอร์โทรศัพท์') }}</label>
                <input v-model="filter.phoneNumber" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('อีเมล') }}</label>
                <input v-model="filter.email" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('วันที่สมัคร - start') }}</label>
                <DatePickerWithoutButton v-model="filter.dateFrom">
                  <input
                    readonly
                    :value="formatdate(filter.dateFrom)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('วันที่สมัคร - end') }}</label>
                <DatePickerWithoutButton v-model="filter.dateTo">
                  <input
                    readonly
                    :value="formatdate(filter.dateTo)"
                    class="form-control"
                    type="text"
                  />
                </DatePickerWithoutButton>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showImageDialog" width="550px">
      <div>
        <v-img
          @click="showImageDialog = false"
          v-if="showImageDialog"
          :src="currentShowImage"
        ></v-img>
      </div>
    </v-dialog>
    <v-dialog persistent width="950px" v-model="editModal">
      <v-card v-if="editModal">
        <MemberEdit
          @onsave="oneditmember"
          @close="editModal = false"
          :editdata="editdata"
        ></MemberEdit>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import MemberEdit from './MemberEdit.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import api from '@/api'
import SearchMember from './SearchMember.vue'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
export default {
  components: {
    Multiselect,
    SearchMember,
    DatePickerWithoutButton,
    MemberEdit,
    exportxlsx
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      editModal: false,
      branchOptions: '',
      editdata: '',
      showImageDialog: false,
      currentShowImage: '',
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      showsearch: false,
      filter: {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        email: '',
        branch: '',
        dateFrom: '',
        dateTo: ''
      },
      loading: false,

      items: [],
      headers: [
        { text: 'ชื่อ-นามสกุล', value: 'first_name' },
        { text: 'วันเดือนปีเกิด', value: 'dob' },
        { text: 'เลขบัตรประชาชน', value: 'identity_number' },
        { text: 'เบอร์โทร', value: 'phone_number' },
        { text: 'อีเมล', value: 'email' },
        { text: 'ไลน์', value: 'linename' },
        { text: 'อาชีพ', value: 'job' },
        { text: 'คะแนน', value: 'points' },
        { text: 'บัตรประชาชน', value: 'idcard' },
        { text: '', value: '' }
      ],
      memberStatus: null
    }
  },
  mounted() {
    this.getData(false, true)
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        var data = await this.getData(true)

        resolve(
          data.map((el) => {
            if (el.member_status == 'true') {
              this.memberStatus = 'อนุมัติแล้ว'
            } else {
              this.memberStatus = 'None'
            }

            return {
              เลขบัตรประชาชน: el.identity_number,
              ชื่อลูกค้า: el.first_name + ' ' + el.last_name,
              วันเกิด: moment(el.dob).format('DD/MM/YYYY'),
              เบอร์โทร: el.phone_number,
              อีเมล: el.email,
              อาชีพ: el.job,
              ห้าง: el.department_store,
              สาขา: el.branch,
              ภาพบัตรประชาชน: el.identity_number_image,
              สถานะการตรวจสอบข้อมูล: this.memberStatus,
              ผู้ตรวจ: el.approve_by,
              วันที่ตรวจ: el.approve_timestamp
                ? moment(el.approve_timestamp).format('DD/MM/YYYY HH:mm')
                : '',
              คะแนนคงเหลือ: el.points,
              วันที่สมัครสมาชิก: el.registertimestamp
                ? moment(el.registertimestamp).format('DD/MM/YYYY HH:mm')
                : ''
            }
          })
        )
      })
    },
    oneditmember() {
      this.editModal = false
      this.getData()
    },
    showEdit(item) {
      this.editdata = item
      this.editModal = true
    },
    showImage(item) {
      this.currentShowImage = item.identity_number_image
      this.showImageDialog = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData(false, true)
      }
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        email: '',
        branch: '',
        dateFrom: '',
        dateTo: ''
      }
      this.onsearch()
    },
    formatdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    },

    getData(getall = false, isFirst = false) {
      return new Promise((resolve) => {
        if (!isFirst) {
          this.offset = 0
          this.pagetmp = 1
          this.pageNumber = 1
        }
        var data = {
          pageid: this.selectedBot.pageid,
          name: this.filter.name, // filter ชื่อ
          identityNumber: this.filter.identityNumber, // filter บัตรปชช.
          phoneNumber: this.filter.phoneNumber, // filter เบอร์โทร
          email: this.filter.email, // filter email
          branch: this.filter.branch, // filter ชื่อสาขา
          dateFrom: this.filter.dateFrom, // YYYY-MM-DD
          dateTo: this.filter.dateTo // YYYY-MM-DD
        }
        if (!getall) {
          Object.assign(data, {
            limit: this.limit,
            offset: this.offset
          })
        }
        this.loading = true
        api.getmembertoacrm(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            if (!getall) {
              this.items = response.data
              this.total = response.total
            }
            resolve(response.data)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Member.vue